<div class="title" fxLayout="row" fxLayoutAlign="start" cdkFocusInitial>
  <span *ngIf="modalIconNameString && modalIconNameString!=''">
    <mat-icon class="modal-icon">{{modalIconNameString}}</mat-icon>
  </span>
  <span mat-dialog-title role="heading" aria-level="1" *ngIf="data.title">{{ data.title }}</span>
</div>
<div class="separator color_secondary"></div>
<div class="sub-title" fxLayout="row" fxLayoutAlign="start" *ngIf="data && data.subtitle">
  <span mat-dialog-title [ngStyle]="{'color': data.subtitleTextColor}" role="heading" aria-level="2" [innerHTML]="data.subtitle"></span>
</div>
<div mat-dialog-content>
  <div *ngIf="data && data.message" fxLayout="row" fxLayoutAlign="center center">
    <p class="dialog-message" [innerHTML]="data.message"></p>
  </div>
  <div *ngIf="getResponse && !getResponseMax">
    <textarea type="text" class="response_layout" [(ngModel)]="data.response"></textarea>
  </div>
  <div *ngIf="getResponse && getResponseMax">
    <textarea type="text" class="response_layout" [(ngModel)]="data.response" [maxlength]="getResponseMax"></textarea>
    <mat-hint>{{ getResponseMax - data.response.length }} characters remaining</mat-hint>
  </div>
  <div *ngIf="getSelectResponse">
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
      <mat-select ngModel [(ngModel)]="data.selectResponse" placeholder="Please Select">
        <mat-option *ngFor="let value of data.selectData" [value]="value">
          {{value}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="data && data.checkBox && data.cbText">
    <mat-checkbox name="agree" [(ngModel)]="checkBoxVal" required class="epds_mat_override">
      {{data.cbText}}
    </mat-checkbox>
  </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
  <button *ngIf ="cancelBtn" mat-raised-button [color]="cancelButtonColorString"  (click)="cancel()"
          [disabled]="data.checkBox && !checkBoxVal">{{ data.cancelText }}</button>
  <button mat-raised-button [color]="confirmButtonColorString" (click)="confirm()"
          [disabled]="(data.checkBox && !checkBoxVal) || (data.responseReq && data.response?.length === 0) ||
           (data.selectReq && data.selectResponse?.length === 0)">{{ data.confirmText }}</button>
</div>
